import React from "react";
const TEMPLATES_IMAGE = "https://cdn.magicpatterns.com/uploads/i1ALHCp4MihBDaGDVhmmQS/collage_calido_de_menu_de_reposteria_artesanal.webp";
export function InstagramPreview() {
  return <div className="overflow-hidden rounded-xl bg-cream-50 ring-1 ring-cocoa-900/10" data-id="element-75" data-mp="2wrdj93js81vp">
      <img src={TEMPLATES_IMAGE} alt="Plantillas editables para Instagram y catálogo: menú semanal, sobre nosotras, productos y cómo hacer tu pedido" width={1448} height={1086} loading="lazy" className="block h-auto w-full" data-id="element-76" data-mp="31ic0q6gib60j" />
    </div>;
}